import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="2 2 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 8.1C13 7.81727 12.9735 7.53428 12.921 7.25954C12.8973 7.13517 12.7883 7.04529 12.6619 7.04529H8.51758C8.37184 7.04529 8.25391 7.16322 8.25391 7.30897V8.891C8.25391 9.03674 8.37184 9.15467 8.51758 9.15467H10.644C10.5115 9.42288 10.3289 9.65559 10.1145 9.85138L11.6048 11.3417C12.4622 10.5247 13 9.3751 13 8.1Z"
      fill="currentColor"
    />
    <path
      d="M8.5 5.70937C9.01731 5.70937 9.50937 5.87366 9.9229 6.1847C10.0274 6.26324 10.175 6.25372 10.2677 6.16023L11.3929 5.03499C11.4452 4.98271 11.4733 4.91087 11.4699 4.83697C11.4666 4.76307 11.4326 4.69406 11.3759 4.64642C10.5708 3.97156 9.54927 3.6 8.5 3.6C6.95578 3.6 5.59156 4.38493 4.78509 5.57669L6.33281 7.12441C6.70206 6.29269 7.53283 5.70937 8.5 5.70937Z"
      fill="currentColor"
    />
    <path
      d="M8.5 12.6C9.50658 12.6 10.4335 12.2625 11.1825 11.7002L9.66422 10.182C9.31719 10.3774 8.92056 10.4906 8.5 10.4906C7.53283 10.4906 6.70206 9.90731 6.33281 9.07558L4.78509 10.6233C5.59156 11.8151 6.95578 12.6 8.5 12.6Z"
      fill="currentColor"
    />
    <path
      d="M6.14777 8.47977C6.12757 8.35534 6.10938 8.23002 6.10938 8.1C6.10938 7.96997 6.12757 7.84466 6.14777 7.72022L4.49324 6.0657C4.18021 6.67707 4 7.36727 4 8.1C4 8.83273 4.18021 9.52293 4.49326 10.1343L6.14777 8.47977Z"
      fill="currentColor"
    />
  </SvgIcon>
));
